<csl-non-prod-banner [environment]="environment"></csl-non-prod-banner>
<div id="layout-container">

  @if (this.globalStore.progBarIsLoading()) {
    <p-progress-bar mode="indeterminate" [style]="{'height': '0.4em'}" color="#015989"></p-progress-bar>
  }
  @if (!this.globalStore.progBarIsLoading()) {
    <div class="progress-bar"></div>
  }

  <nav>
    <app-admin-site-header></app-admin-site-header>
  </nav>

  <!--  <app-admin-home-breadcrumb></app-admin-home-breadcrumb>-->
  <div class="h-8"></div>

  <div class="content">
    <aside>

      <ul>
        <li><a routerLinkActive="active-button" routerLink="dashboard"><i class="fa-solid fa-gauge fa-xl mr-2 opacity-75 min-w-6"></i>Dashboard</a></li>
        <li><a routerLinkActive="active-button" routerLink="users"><i class="fa-solid fa-users fa-xl mr-2 opacity-75 min-w-6"></i>Users</a></li>
        <li><a routerLinkActive="active-button" routerLink="hr-index"><i class="fa-solid fa-clipboard-medical fa-xl mr-2 opacity-75 min-w-6"></i>Health Records</a></li>
        <li><a routerLinkActive="active-button" routerLink="hr-tx" class="two-line-text">
          <div class="flex flex-row items-center">
            <i class="fa-solid fa-swap fa-rotate-90 fa-xl mr-2 opacity-80 min-w-5"></i>
            <span class="inline-block">Owner Transfers</span>
            @if (adminGlobalStore.pendingOwnerTransferRequestCount() > 0) {
              <csl-count-badge [value]="adminGlobalStore.pendingOwnerTransferRequestCount()"></csl-count-badge>
            } @else {
              <div class="count-badge"></div>
            }
          </div>
        </a></li>
        <li><a routerLinkActive="active-button" routerLink="hr-lg" class="two-line-text">
          <div class="flex flex-row items-center justify-between">
            <div class="flex flex-row items-center">
              <i class="fa-solid fa-hands-holding-child fa-xl mr-2 opacity-75 min-w-6"></i>
              <span class="inline-block">Legal Guardian<br/>Requests</span>
              @if (adminGlobalStore.pendingLegalGuardianRequestCount() > 0) {
                <csl-count-badge [value]="adminGlobalStore.pendingLegalGuardianRequestCount()"></csl-count-badge>
              } @else {
                <div class="count-badge"></div>
              }
            </div>
          </div>
        </a>
      </li>
      <li><a routerLinkActive="active-button" routerLink="clinics"><i class="fa-solid fa-house-medical fa-xl mr-2 opacity-75 min-w-6"></i>Clinics</a></li>
      <li><a routerLinkActive="active-button" routerLink="reports"><i class="fa-solid fa-chart-column fa-xl mr-2 opacity-75 min-w-6"></i>Reports</a></li>
      @if (featureFlagService.isEnabled('pfc_integration')) {
        <li><a routerLinkActive="active-button" routerLink="pfc-sessions" class="two-line-text">
          <div class="flex flex-row items-center">
            <img [src]="pfcLogoUrl" alt="Passport for Care" class="mr-2 pfc-nav-icon" style="width: 1.5rem; height: 1.5rem; object-fit: contain;">
            <span class="inline-block">Passport<br/>for Care</span>
          </div>
        </a></li>
      }
    </ul>


  </aside>

  <div class="flex flex-col w-full">
    <main class="p-6">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>


<app-admin-site-footer></app-admin-site-footer>

</div>


<div id="messages-toast" class="card flex justify-center">
  <p-toast />
</div>

<p-drawer id="helpDrawer" [visible]="showHelp()" position="bottom" [style]="{ 'height': 'auto', 'border-top-left-radius': '20px', 'border-top-right-radius': '20px'}" (onHide)="onHelpDrawerHide()">
  <div [innerHTML]="helpService.helpContent()"></div>
  <ng-template #header>
    <span class="font-semibold text-xl text-gray-500">{{helpService.helpTitle() ?? 'SurvivorLink Help'}}</span>
  </ng-template>
</p-drawer>
